import React, { Component } from 'react';

import { EntityGrid } from 'hay-core-react';
import { ModelInputNumber } from 'hay-core-react';
import { ModelTextArea } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import TermoUso from '../../../models/TermoUso';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    id:            { exibir: 'main.id', tipo: 'numeric', largura: '5rem', fixar: true },
    versao:        { exibir: 'main.termouso.versao', visivel: true, tipo: 'numeric', validacao: { obrigatorio: true } },
    dataaprovacao: { exibir: 'main.termouso.dataaprovacao', visivel: true, tipo: 'date', time: true },
    texto:         { exibir: 'main.termouso.texto', linhas: 12, validacao: { obrigatorio: true } },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

// Um TermoUso pode ser editado livremente enquanto não tiver dataaprovacao definida — assim que
// aprovado, todos os campos ficam desabilitados (mesma trava aplicada no backend em
// TermoUso.beforeUpdate). É a própria dataaprovacao que marca o termo como final.
class TermoUsoFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        const jaAprovado = !!model.dataaprovacao.value;
        return (
            <div className="grid">
                <div className="field col-12 md:col-4 mt-3">
                    <ModelInputNumber model={{ ...model.versao, disabled: jaAprovado }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelCalendar model={{ ...model.dataaprovacao, disabled: jaAprovado }} contexto={contexto} />
                </div>
                <div className="field col-12 mt-3">
                    <ModelTextArea model={{ ...model.texto, disabled: jaAprovado }} contexto={contexto} />
                </div>
            </div>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class TermoUsoTemplate extends Component {
    render() {
        return (
            <EntityGrid
                ref={(ref) => this.gridRef = ref}
                entidade={TermoUso}
                model={model}
                identidade="main.termouso"
                permissoes={this.props.permissoes}
                icone="pi-file-check"
                storageKey="dt-termosuso"
                configuracao={this.props.configuracao}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                formulario={(m, ctx) => <TermoUsoFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default TermoUsoTemplate;
